import { getActiveScreenChannelOptions } from 'src/modules/Redux';
import { useAppSelector } from 'src/modules/Redux/store';
import { Image } from './styles';

const ImagePage = () => {
    const channelOptions = useAppSelector(getActiveScreenChannelOptions);
    const imageURL = channelOptions?.options?.imageURL || '';

    if (!imageURL) return null;

    return <Image url={imageURL} />;
};

export default ImagePage;
